<template>
	<sui-form-field>
		<sui-dropdown
			ref="select"
			fluid
			:class="{ disabled: disabled }"
			:options="options"
			:placeholder="placeholder"
			:value="value"
			selection
			search
			:no-results-message="mensajeVacio"
			@input="onInput"
		/>
		<div style="margin-top: 5px;">
			<span v-show="error" :class="$style.danger">
				<sui-icon name="exclamation circle" />Dato obligatorio
			</span>
		</div>
	</sui-form-field>
</template>

<script>
export default {
	props: {
		placeholder: {
			type: String,
			default: 'Selecciona un estatus'
		},
		titulo: {
			type: String,
			default: 'Estatus'
		},
		value: {
			type: Number,
			default: null
		},
		mensajeVacio: {
			type: String,
			default: 'No se encontraron estatus'
		},
		error: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		selected: {
			type: String,
			default: null
		},
		sinTitulo: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {};
	},

	computed: {
		options: function() {
			return [
				{ value: -2, text: 'ALUMNOS ACTIVOS' },
				{ value: -1, text: 'TODOS LOS ESTATUS' },
				{ value: 0, text: 'ALUMNOS SIN ENTRAR' },
				{ value: 1, text: 'VERIFICANDO INFORMACIÓN' },
				{ value: 2, text: 'SUBIENDO ARCHIVOS' },
				{ value: 3, text: 'REVISIÓN DOCUMENTOS' },
				{ value: 4, text: 'SUBIENDO COMPROBANTE' },
				{ value: 5, text: 'REVISIÓN COMPROBANTE' },
				{ value: 6, text: 'TERMINADO' },
				{ value: -3, text: 'ALUMNOS CON E.TITULO' }
			];
		}
	},
	watch: {},
	methods: {
		onInput(val) {
			this.$emit('input', val);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.titulo {
	font-size: 14px !important;
	color: #5c5d5d !important;
}
.danger {
	color: #9f2241 !important;
}
</style>
